module.exports = __webpack_public_path__ + "img/Img4_204715_BiEq-5-12.f6b0f660.jpg";